import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import jwt_decode from 'jwt-decode';
import {Route, Router} from '@angular/router';
import {UserService} from './user.service';
import {ToastrModule, ToastrService} from 'ngx-toastr';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  http = new HttpClient(this.handler);

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
              private handler: HttpBackend,
              private router: Router,
              private userService: UserService,
              private appHttp: HttpClient,
              private toastr: ToastrService) {

  }


  isLogedIn(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return !!localStorage.getItem('access');
    }
    return false;
  }

  logout(): void {
         if (isPlatformBrowser(this.platformId)) {

           localStorage.removeItem('access');
           localStorage.removeItem('token');
         }
    this.userService.deleteUser();
    this.router.navigate(['/auth/login']);
  }

  getRefreshToken(): string {
         if (isPlatformBrowser(this.platformId)) {

           const refresh = localStorage.getItem('refresh');
           if (this.isTokenExpired(refresh)) {
             return null;
           } else {
             return refresh;
           }
         }
  }

  getAccessToken(): Promise<string> {
         if (isPlatformBrowser(this.platformId)) {

           let access = localStorage.getItem('access');
           if (this.isTokenExpired(access)) {
             return this.refreshAccessToken().then((res: any) => {
               access = res.access;
               this.setToken(access, null);
               return access;
             }).catch(error => {
               return '';
             }).finally(() => {
               return access;
             });
           } else {
             return new Promise<string>(resolve => {
               resolve(access);
             });
           }
         }
  }

  setToken(access: string, refresh: string): void {
         if (isPlatformBrowser(this.platformId)) {

           if (access) {
             localStorage.setItem('access', access);
           }
           if (refresh) {
             localStorage.setItem('refresh', refresh);
           }
         }
  }


  getDecodeToken(token): any {
    return jwt_decode(token);
  }

  getExpiryTime(token): any {
    const decode = this.getDecodeToken(token);
    return decode ? decode.exp : null;
  }

  isTokenExpired(token): boolean {
    if (!token) {
      return true;
    }
    const expiryTime: number = this.getExpiryTime(token);
    if (expiryTime) {
      return ((1000 * expiryTime) - (new Date()).getTime()) < 5000;
    } else {
      return false;
    }
  }

  login(username, password): Promise<any> {
    return this.http.post('api/token/', {username, password})
      .toPromise().then((res: any) => {
        this.setToken(res.access, res.refresh);
        return this.userService.fetchUser().then(() => {
          return res;

        });


      }).catch(err => {
        this.toastr.error('کلمه عبور اشتباه است!', 'خطایی رخ داد!', {positionClass: 'toast-top-left'});

      });
  }

  // tslint:disable-next-line:variable-name
  isPhoneNumberExist(phone_number): Promise<any> {
    const result = {
      exists: false,
      error: ''
    };
    return this.http.post('api/users/exists', {phone_number})
      .toPromise();
  }

  private refreshAccessToken(): Promise<any> {
    const refresh = this.getRefreshToken();
    if (!refresh) {
      return new Promise<any>((resolve, reject) => {
        reject();
      });
    }
    return this.http.post('api/token/refresh/', {refresh})
      .toPromise().then((res: any) => {
        this.setToken(res.access, null);
        return res;
      });
  }
}
